import type { FormItemProps, InputProps, InputRef } from "antd";

import { SFormItem } from "@styled-components/form/SFormItems";
import { SInput } from "@styled-components/form/SInputs";
import { useEffect, useRef } from "react";

interface Props extends FormItemProps {
  inputProps?: InputProps;
}

export const InputField: React.FunctionComponent<Props> = ({
  inputProps,
  ...props
}) => {
  /* This put focus on the current field */
  const inputTagRef = useRef<InputRef>(null);

  useEffect(() => {
    if (inputProps?.autoFocus && inputTagRef.current) {
      inputTagRef.current.focus();
    }
  }, [inputTagRef.current, inputProps?.autoFocus]);

  return (
    <SFormItem {...props}>
      <SInput
        ref={inputTagRef}
        {...inputProps}
        bordered={inputProps?.bordered ?? false}
      />
    </SFormItem>
  );
};
